import { NgClass, NgFor, NgIf } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { Subscription, interval } from 'rxjs';
import { ConnectionDetail, Station } from '../../core/models';
import { HttpService, MapService } from '../../core/services';
import { LoadingComponent } from '../../shared/components';
import { BreakAfterCommaPipe, TranslationPipe } from '../../shared/pipes';
import { LayerService } from '../map/services';
import { ConnectionIcons } from './connection-icons/connection-icons.component';
import { LatLng } from 'leaflet';

@Component({
  selector: 'app-connection-detail',
  styleUrl: './connection-detail.component.scss',
  standalone: true,
  imports: [NgIf, NgFor, NgClass, RouterLink, TranslationPipe, BreakAfterCommaPipe, LoadingComponent, ConnectionIcons],
  templateUrl: './connection-detail.component.html'
})
export class ConnectionDetailComponent implements OnInit, OnDestroy {
  private readonly refreshSub: Subscription;
  detailId?: string;
  stopFromId?: string;
  timeAtStopFrom: string | undefined;
  stopId?: string;
  crId?: string;
  crTtIndex?: string;
  crDelayQuery?: string;
  connection: ConnectionDetail | undefined = undefined;
  prefname?: string
  hasArrivals: boolean = true;
  delay: number | undefined = undefined;
  loading = false;

  constructor(
    private readonly route: ActivatedRoute,
    private readonly router: Router,
    private readonly httpService: HttpService,
    private readonly mapService: MapService,
    private readonly layerService: LayerService)
  {
    this.refreshSub = interval(10000).subscribe(() => {
      this.refresh();
    });
  }

  ngOnInit() {
    this.loading = true;

    this.route.paramMap.subscribe((params) => {
      this.detailId = params.get('id') ?? '';
      this.stopFromId = params.get('stopId') ?? undefined;
      const snapshot = this.route.snapshot.queryParamMap;
      this.stopId = snapshot.get('crS') ?? '';
      this.crId = snapshot.get('crId') ?? '';
      this.crTtIndex = snapshot.get('crT') ?? '';
      this.crDelayQuery = snapshot.get('crD') ?? '';
      this.httpService.getConn(this.detailId, this.crId, this.stopId, this.crTtIndex, this.crDelayQuery, true).subscribe({
        next: result => {
          this.connection = result;
          this.hasArrivals = this.connection.stations.some((s) => s.arrivalTime !== undefined);
          this.getDelay(this.connection);
          this.processDelays();
          this.getPrefferedName(this.connection);
          if (result.geometry) {
            const mapConn = this.layerService.getConnectionInMap(this.connection.id);
            const position = mapConn ? new LatLng(mapConn?.lat, mapConn?.lon) : undefined;
            this.mapService.showPath([result.geometry, this.connection.id, position, this.connection.lineType]);
          }
            
          if (this.stopFromId) {
            const queryStation = this.connection.stations.filter(s => s.id == this.stopFromId);
            if (queryStation.length > 0)
              this.timeAtStopFrom = queryStation[0].arrivalTime ?? queryStation[0].departureTime;
          }
          this.loading = false;
        }
      });
    });
  }

  ngOnDestroy() {
    this.refreshSub.unsubscribe();
    if (this.connection)
      this.mapService.hidePath(this.connection.id);
  }

  onStationClick(id: string) {
    this.router.navigate([`departures/${id}`]);
  }

  private refresh() {
    if (this.connection) {
      this.httpService.getConn(this.connection.id, this.crId, this.stopId, this.crTtIndex, this.crDelayQuery, true).subscribe({
        next: conn => {
          this.connection = conn;
          this.getDelay(conn);
          this.processDelays();
          this.getPrefferedName(conn);
          if (conn.stations[conn.stations.length - 1].passed)
            this.refreshSub.unsubscribe();
        }
      });
    }    
  }

  private getPrefferedName(conn: ConnectionDetail) {
    if (!conn.extLineName)
      this.prefname = conn.name;
    else if (conn.vehicleType == "V") {
      this.prefname = conn.name;
    }
    else {
      this.prefname = `${conn.extLineName} (${conn.name})`
    }    
  }

  private getDelay(connDetail: ConnectionDetail) {
    for (let i = connDetail.stations.length - 1; i >= 0; i--) {
      const station = connDetail.stations[i];
      if (connDetail.stations[i].passed) {
        if (station.delay && station.delay > 0)
          this.delay = station.delay;

        return;
      }
    }

    this.delay = undefined;
  }

  processDelays() {
    if (this.connection!.stations.length > 0) {
      let lastDelay = 0;
      for (const station of this.connection!.stations) {
        if (station.delay && station.delay > 0) {
          lastDelay = station.delay!;
        }
        else if (lastDelay > 0) {
          station.delay = -1; // tak se pozná dohnání zpoždění
          lastDelay = 0;
        }
      }
    }
  }

  stationHasArrAndDep(item: Station): boolean {
    return this.hasArrivals && item.arrivalTime != null && item.departureTime != null && item.arrivalTime != item.departureTime;
  }
}
